import EventEmitter from 'emittery';
const bus = new EventEmitter();
export default bus;
